<template>
  <div class="add-approval-node">
    <h2>添加多级审批节点</h2>
    <el-table :data="approvalNodes" style="width: 100%; margin-top: 20px">
      <!-- 表格列定义保持不变 -->
      <el-table-column prop="index" label="序号" width="80"></el-table-column>
      <el-table-column label="节点信息">
        <template slot-scope="scope">
          <!-- 使用动态 ref -->
          <el-form :inline="true" :model="scope.row" :rules="approvalFormRules" :ref="`approvalForm${scope.$index}`">
            <!-- 角色选择 -->
            <el-form-item prop="role">
              <el-select v-model="scope.row.role" @change="roleChange(scope.$index)">
                <el-option label="校长" value="principal"></el-option>
                <el-option label="年级组长" value="gradeLeader"></el-option>
                <el-option label="部门主管" value="departmentHead"></el-option>
                <el-option label="班主任" value="classTeacher"></el-option>
                <el-option label="指定人员" value="specificPerson"></el-option>
              </el-select>
            </el-form-item>
            <!-- 指定人员选择 -->
            <el-form-item v-if="scope.row.role === 'specificPerson'" prop="specificUsers">
              <el-select v-model="scope.row.specificUsers" multiple filterable allow-create placeholder="请选择或输入人员"
                @change="specificUsersChange(scope.$index)">
                <el-option v-for="user in userList" :key="user.id" :label="user.name" :value="user.id"></el-option>
              </el-select>
            </el-form-item>
            <!-- 节点名称 -->
            <el-form-item prop="nodeName">
              <el-input v-model="scope.row.nodeName" placeholder="节点名称"></el-input>
            </el-form-item>
            <!-- 输入天数 -->
            <el-form-item prop="days"  label="天数" >
              <el-input v-model.number="scope.row.days" type="number" placeholder="输入天数"
                @input="handleDaysInput(scope.$index)"></el-input>
            </el-form-item>
            <!-- 删除按钮 -->
            <el-form-item>
              <el-button type="danger" @click="removeNode(scope.$index)">删除</el-button>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
    </el-table>
    <!-- 优化按钮布局 -->
    <div style="text-align: center; white-space: nowrap; margin-top: 20px;">
      <el-button type="primary" @click="addNode" style="margin-right: 10px;">添加节点</el-button>
      <el-button type="primary" @click="submitForm" style="margin-right: 10px;">提交</el-button>
      <el-button @click="resetForm">重置</el-button>
    </div>
  </div>
</template>

<script>
// 脚本部分代码保持不变
export default {
  data() {
    return {
      // 存储所有审批节点
      approvalNodes: [],
      // 表单验证规则
      approvalFormRules: {
        nodeName: [
          { required: true, message: '请输入节点名称', trigger: 'blur' }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        specificUsers: [
          { type: 'array', required: false, message: '请选择指定人员', trigger: 'change' }
        ],
        days: [
          {
            type: 'number',
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (value === undefined || value === null || value === '') {
                // 当值为空时，提示请输入天数
                callback(new Error('请输入天数'));
              } else {
                if (typeof value === 'string') {
                  value = Number(value);
                }
                if (isNaN(value)) {
                  callback(new Error('请输入有效的数字'));
                } else if (value <= 0) {
                  callback(new Error('天数必须大于 0'));
                } else {
                  callback();
                }
              }
            }
          }
        ]
      },
      // 模拟用户列表
      userList: [
        { id: 1, name: '张三' },
        { id: 2, name: '李四' },
        { id: 3, name: '王五' }
      ]
    };
  },
  methods: {
    // 添加新节点，默认角色为班主任
    addNode() {
      const newNode = {
        index: this.approvalNodes.length + 1,
        nodeName: '',
        role: 'classTeacher',
        specificUsers: [],
        days: 0, // 新增天数属性
      };
      // 生成默认节点名称
      this.generateNodeName(newNode);
      this.approvalNodes.push(newNode);
    },
    // 删除节点
    removeNode(index) {
      this.approvalNodes.splice(index, 1);
      // 重新更新序号
      this.approvalNodes.forEach((node, i) => {
        node.index = i + 1;
      });
    },
    // 角色改变时，如果不是指定人员则清空指定人员选择
    roleChange(index) {
      console.log(index)
      if (this.approvalNodes[index].role !== 'specificPerson') {
        this.approvalNodes[index].specificUsers = [];
      }
      // 角色改变时重新生成节点名称
      this.generateNodeName(this.approvalNodes[index]);
    },
    // 新增方法，处理指定人员选择变化
    specificUsersChange(index) {
      this.generateNodeName(this.approvalNodes[index]);
    },
    // 生成节点名称的方法
    generateNodeName(node) {
      console.log(node)
      if (node.role === 'specificPerson') {
        const names = node.specificUsers.map(id => {
          const user = this.userList.find(u => u.id === id);
          return user ? user.name : '';
        }).filter(name => name);
        node.nodeName = names.join('、') + '审批';
      } else {
        const roleMap = {
          principal: '校长',
          gradeLeader: '年级组长',
          departmentHead: '部门主管',
          classTeacher: '班主任'
        };
        node.nodeName = (roleMap[node.role] || node.role) + '审批';
      }
    },

    // 处理天数输入
    handleDaysInput(index) {
      const form = this.$refs[`approvalForm${index}`];
      const days = this.approvalNodes[index].days;
      if (form && typeof days === 'number' && days > 0) {
        form.clearValidate('days');
      }
    },
    async submitForm() {
      let isValid = true;
      for (let i = 0; i < this.approvalNodes.length; i++) {
        const form = this.$refs[`approvalForm${i}`];
        if (form) {
          await new Promise((resolve) => {
            form.validate((valid) => {
              if (!valid) {
                isValid = false;
              }
              resolve();
            });
          });
        }
      }

      if (isValid) {
        // 这里可以调用 API 提交表单数据
        console.log('提交的表单数据:', this.approvalNodes);
        this.$message.success('提交成功');
      } else {
        this.$message.error('表单存在验证错误，请检查');
      }
    },
    // 重置表单
    resetForm() {
      this.approvalNodes = [];
    }
  }
};
</script>

<style scoped>
.add-approval-node {
  padding: 20px;
}
</style>